
import { computed, defineAsyncComponent, defineComponent } from 'vue';
import {
  Badge, Avatar, Popover,
} from 'ant-design-vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import getDefaultRoutes from '@/router/defaultRoutes';
import { UserRole } from '@/types/user';

export default defineComponent({
  components: {
    aBadge: Badge,
    bIcon: defineAsyncComponent(() => import('@/components/BaseIcon.vue')),
    aAvatar: Avatar,
    aPopover: Popover,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const role = sessionStorage.getItem('role') as UserRole | null;

    function changePath(path: string) {
      if (route.path === path) {
        return;
      }
      router.push(path);
    }
    function outLogin() {
      localStorage.clear();
      sessionStorage.clear();
      router.go(0);
    }
    function back() {
      if (role === 'student') {
        router.push('/Student');
      } else if (role === 'teacher') {
        router.push('/Teacher/userlist');
      } else if (role === 'admin') {
        router.push('/Teacher/userlist');
      } else {
        router.push('/Login');
      }
    }

    const navList = getDefaultRoutes(role);
    const user = computed(() => store.state.user.user);
    const active = computed(() => navList.findIndex(((value) => route.path === value.path)));
    const softConfig = computed(() => store.state.system.softConfig);
    return {
      navList,
      changePath,
      outLogin,
      active,
      softConfig,
      back,
      user,
    };
  },
});
